  <div class="flex items-center justify-between px-2 py-1.5 sm:px-4 sm:py-2 border-b">
    <h2 class="text-base sm:text-xl font-bold flex items-center gap-1.5 sm:gap-2 m-0">
      <mat-icon>link</mat-icon>
      <span class="hidden sm:inline">Relaciones de rutas</span>
      <span class="sm:hidden">Relaciones</span>
    </h2>
    <button mat-icon-button (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

    <mat-dialog-content class="!p-0" >
    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      animationDuration="0ms">

      <!-- Tab: Vehiculos -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center gap-1 sm:gap-2">
            <mat-icon>local_shipping</mat-icon>
            <span class="hidden sm:inline">Con vehículos</span>
          </div>
        </ng-template>
          <app-vehicles-tab />
      </mat-tab>

      <!-- Tab: Usuarios -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center gap-1 sm:gap-2">
            <mat-icon>people</mat-icon>
            <span class="hidden sm:inline">Con usuarios</span>
          </div>
        </ng-template>
          <app-users-tab />
      </mat-tab>

      <!-- Tab: Socios de Negocio -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center gap-1 sm:gap-2">
            <mat-icon>business</mat-icon>
            <span class="hidden sm:inline">Con clientes</span>
          </div>
        </ng-template>
          <app-business-partners-tab />
      </mat-tab>

    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions class="flex justify-end gap-1.5 sm:gap-2 p-2 sm:p-4 border-t">
    <button mat-button (click)="closeModal()">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </mat-dialog-actions>
